import { intlService } from '~/i18n/IntlService';
import {
  Guideline,
  Playbook,
  PlaybookWithId,
} from '~/redux/api/types/playbooks/playbooks';

export const isGuidelineValid = (guideline: Guideline) => {
  return guideline.name.trim().length > 0 && guideline.guideline.length > 0;
};

export const isPlaybookValid = (playbook: Playbook) => {
  return (
    playbook.name.trim().length > 0 &&
    Array.isArray(playbook.guidelines) &&
    playbook.guidelines.length > 0 &&
    playbook.guidelines.every(isGuidelineValid) &&
    (playbook.restrictions?.workflow_ids?.length ?? 0) > 0
  );
};

export const getPlaybookErrors = (playbook: Playbook) => {
  const errors: string[] = [];
  const intl = intlService.getIntl();

  if (playbook.name.trim().length === 0) {
    errors.push(
      intl.formatMessage({
        id: 'playbooks.Setup.validation.nameRequired',
        defaultMessage: 'Enter a Playbook name.',
        description: 'Validation error message when playbook name is empty',
      }),
    );
  }

  if (!Array.isArray(playbook.guidelines) || playbook.guidelines.length === 0) {
    errors.push(
      intl.formatMessage({
        id: 'playbooks.Setup.validation.guidelineRequired',
        defaultMessage: 'Add at least one guideline.',
        description: 'Validation error message when no guidelines are provided',
      }),
    );
  } else {
    playbook.guidelines.forEach((guideline, index) => {
      if (guideline.name.trim().length === 0) {
        errors.push(
          intl.formatMessage(
            {
              id: 'playbooks.Setup.validation.guidelineNameRequired',
              defaultMessage: 'Guideline {number}: Name is required.',
              description:
                'Validation error message when guideline name is empty',
            },
            { number: index + 1 },
          ),
        );
      }
      if (guideline.guideline?.trim().length === 0) {
        errors.push(
          intl.formatMessage(
            {
              id: 'playbooks.Setup.validation.guidelineTextRequired',
              defaultMessage: 'Guideline {number}: Guideline text is required.',
              description:
                'Validation error message when guideline text is empty',
            },
            { number: index + 1 },
          ),
        );
      }
    });
  }

  if ((playbook.restrictions?.workflow_ids?.length ?? 0) === 0) {
    errors.push(
      intl.formatMessage({
        id: 'playbooks.Setup.validation.workflowRequired',
        defaultMessage: 'Select at least one workflow.',
        description: 'Validation error message when no workflows are selected',
      }),
    );
  }
  return errors;
};

export const isPlaybookDirty = (
  playbook: Playbook,
  playbookToEdit?: PlaybookWithId,
) => {
  return (
    JSON.stringify({
      ...playbook,
      guidelines: playbook?.guidelines?.map((guideline) => ({
        ...guideline,
        isReadOnly: undefined,
      })),
    }) !== JSON.stringify({ ...playbookToEdit })
  );
};
